// src/lib/toast.js — notificações no padrão shadcn/sonner (flat).
// Cartão neutro (surface + borda) com dot semântico — a cor indica o tipo,
// nunca pinta o toast inteiro. API inalterada:
// showToast(msg, 'success'|'error'|'warning'|'info', durationMs)

const DOT = {
  success: 'var(--sc-ok)',
  error: 'var(--sc-bad)',
  warning: 'var(--sc-warn)',
  info: 'var(--sc-info)',
};

let _container = null;

function _ensureContainer() {
  if (_container) return _container;
  _container = document.createElement('div');
  _container.id = 'toast-container';
  Object.assign(_container.style, {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: '9800',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    pointerEvents: 'none',
  });
  document.body.appendChild(_container);
  return _container;
}

export function showToast(message, type = 'success', durationMs = 3500) {
  const container = _ensureContainer();
  const dot = DOT[type] || DOT.success;
  // os tokens shadcn são escopados em .sc-scope — o container vive no body, então
  // ele mesmo carrega o escopo (e o dark) pra var(--popover)/--border resolverem.
  const light = document.documentElement.classList.contains('light');
  container.className = light ? 'sc-scope' : 'sc-scope dark';

  const toast = document.createElement('div');
  Object.assign(toast.style, {
    background: 'var(--popover, #161B1D)',
    color: 'var(--popover-foreground, #F9FBFB)',
    border: '1px solid var(--border, rgba(255,255,255,.10))',
    padding: '11px 14px',
    borderRadius: '10px',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '1.45',
    boxShadow: '0 8px 24px rgba(0,0,0,.25)',
    maxWidth: '380px',
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '9px',
    transition: 'opacity .25s, transform .25s',
    opacity: '0',
    transform: 'translateX(20px)',
  });

  const dotEl = document.createElement('span');
  Object.assign(dotEl.style, {
    width: '8px', height: '8px', borderRadius: '50%',
    background: dot, flexShrink: '0', marginTop: '5px',
  });
  const msgEl = document.createElement('span');
  msgEl.textContent = message;
  toast.appendChild(dotEl);
  toast.appendChild(msgEl);
  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(20px)';
    setTimeout(() => toast.remove(), 250);
  }, durationMs);
}
